var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJpg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 40,
    viewBox: "0 0 31 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_jpg",
    "data-name": "icona jpg",
    transform: "translate(-106 -134)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1451",
    "data-name": "Raggruppa 1451",
    transform: "translate(109 134)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_263",
    "data-name": "Tracciato 263",
    d: "M98.062,0A2.32,2.32,0,0,0,96,2.5v35A2.32,2.32,0,0,0,98.062,40h20.625a2.32,2.32,0,0,0,2.063-2.5V10L112.5,0Z",
    transform: "translate(-96)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_264",
    "data-name": "Tracciato 264",
    d: "M354.063,10h6.188L352,0V7.5A2.32,2.32,0,0,0,354.063,10Z",
    transform: "translate(-335.5)",
    fill: "#b0b7bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_265",
    "data-name": "Tracciato 265",
    d: "M390.188,135.5,384,128h6.188Z",
    transform: "translate(-365.438 -118)",
    fill: "#cad1d8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_1452",
    "data-name": "Raggruppa 1452"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_266",
    "data-name": "Tracciato 266",
    d: "M63,257.417A1.464,1.464,0,0,1,61.708,259H33.292A1.464,1.464,0,0,1,32,257.417V241.583A1.464,1.464,0,0,1,33.292,240H61.708A1.464,1.464,0,0,1,63,241.583Z",
    transform: "translate(74 -91.333)",
    fill: "#9a19be"
  }), /*#__PURE__*/React.createElement("text", {
    id: "JPG",
    transform: "translate(112 161.667)",
    fill: "#fff",
    fontSize: 10,
    fontFamily: "Poppins-SemiBold, Poppins",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "JPG"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpg);
export default __webpack_public_path__ + "static/media/jpg.3d0456d87eccfca4a88a58bdd169f585.svg";
export { ForwardRef as ReactComponent };